// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3unXj","colMin":"styles_colMin__1ald8"};